export enum RegimeTypeEnum {
  SIMPLE = 'SIMPLES',
  SIMPLE_EXCEDEED = 'SIMPLES EXCEDIDO',
  NORMAL = 'NORMAL',
}

export enum RegimeTypeIdEnum {
  'SIMPLES' = 1,
  'SIMPLES EXCEDIDO' = 2,
  'NORMAL' = 3,
}

export function getRegimeTypeDescriptionByValue(value: number) {
  const indexOfS = Object.values(RegimeTypeIdEnum).indexOf(
    value as unknown as RegimeTypeIdEnum
  );

  const key = Object.keys(RegimeTypeIdEnum)[indexOfS];

  return key;
}


